<template>
  <div v-if="normalizeCollapseOptions.length">
    <el-collapse v-model="collapseParent" class="collapsed without-bottom-b" accordion>
      <el-collapse-item
        v-for="(item, index) in normalizeCollapseOptions"
        :key="index"
        :title="item.title"
        :name="item.name"
      >
        <div v-if="!item.hasChildCollapse || !item.collapseChildOptions">
          <component
            :is="element.type"
            v-for="(element, i) in item.items"
            :key="i"
            :title="element.title"
            :default="element.default"
            :default1="element.default1"
            :default2="element.default2"
            :default3="element.default3"
            :valueselectdefault="element.valueselectdefault"
            :hint="element.hint"
            :min="element.min"
            :max="element.max"
            :step="element.step"
            :status="element.status"
            :options="element.options"
            :parameter="element.parameter"
            :event-click="element.eventClick"
            :default-buttons="element.defaultButtons"
            :default-icons="element.defaultIcons"
            :default-position="element.defaultPosition"
            :default-background="element.defaultBackground"
            :default-color="element.defaultIconsColor"
            :icons-size="element.iconsSize"
            :inner-component="element.innerComponent"
            :text-placeholder="element.textPlaceholder"
            :element="element"
            @changeOption="changeOption"
          />
        </div>
        <el-collapse
          v-if="item.collapseChildOptions"
          v-model="collapseChildren"
          class="collapsed child-collapse"
          accordion
        >
          <el-collapse-item
            v-for="(itemInner, ikey) in item.collapseChildOptions"
            :key="ikey"
            :title="itemInner.title"
            :name="itemInner.name"
          >
            <div v-if="!itemInner.hasChildCollapse">
              <component
                :is="element.type"
                v-for="(element, i) in itemInner.items"
                :key="i"
                :title="element.title"
                :default="element.default"
                :default1="element.default1"
                :default2="element.default2"
                :default3="element.default3"
                :valueselectdefault="element.valueselectdefault"
                :hint="element.hint"
                :min="element.min"
                :max="element.max"
                :step="element.step"
                :status="element.status"
                :options="element.options"
                :parameter="element.parameter"
                :event-click="element.eventClick"
                :default-buttons="element.defaultButtons"
                :default-icons="element.defaultIcons"
                :default-position="element.defaultPosition"
                :default-background="element.defaultBackground"
                :default-color="element.defaultIconsColor"
                :icons-size="element.iconsSize"
                :inner-component="element.innerComponent"
                :text-placeholder="element.textPlaceholder"
                :element="element"
                @changeOption="changeOption"
              />
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { enabledField } from "@/mixins/enabledField.mixin";

import collapseParent from "@/store/observable/option-elements-parent";
import collapseCSS from "@/store/observable/option-elements-css";
import collapseChildCSS from "@/store/observable/option-elements-child-css";

import collapseJS, { collapseJSReactive } from "@/store/observable/option-elements-js";
import collapseChildJS from "@/store/observable/option-elements-child-js";

import SelectInput from "@/widgets/options/SelectInput";
import SelectInputCustom from "@/widgets/options/SelectInputCustom";
import NumberInput from "@/widgets/options/NumberInput";
import TextInput from "@/widgets/options/TextInput";
import SeoTextInput from "@/widgets/options/SeoTextInput";
import SelectExtendedNum from "@/widgets/options/SelectExtendedNum";
import RadioExtendedNum from "@/widgets/options/RadioExtendedNum";
import RadioExtendedNumText from "@/widgets/options/RadioExtendedNumText";
import SliderInput from "@/widgets/options/SliderInput";
import RadioInput from "@/widgets/options/RadioInput";
import RadioInputAltImage from "@/widgets/options/RadioInputAltImage";
import OrderInput from "@/widgets/options/OrderInput";
import SpinControlPanel from "@/widgets/options/SpinControlPanel";
import NumberInputCustomDouble from "@/widgets/options/NumberInputCustomDouble";
import NumberInputSelect from "@/widgets/options/NumberInputSelect";
import NumberInputThreeSelect from "@/widgets/options/NumberInputThreeSelect";

// Helper function to map a parameter string to its accordion section names
function getSectionNamesFromParameter(parameter) {
  let parentName = ''; // Default to Zoom
  let childName = '';  // Default to no child

  if (!parameter || typeof parameter !== 'string') return { parentName, childName };

  // Map prefixes to parent section names (based on default.json structure)
  if (parameter.startsWith('zoom.')) parentName = '1';
  else if (parameter.startsWith('spin.')) {
    parentName = '2';
    // Determine child based on second part
    if (parameter.startsWith('spin.hint.')) childName = '3';
    else if (parameter.startsWith('spin.autospin.')) childName = '2';
    else if (parameter.startsWith('spin.zoom.')) childName = '4';
    else if (parameter.startsWith('spin.control.')) childName = '6';
    // Check for 'column.' before just 'row.'
    else if (parameter.startsWith('spin.column.')) childName = '1'; // Assuming 'Spin' child is '1'
    else if (parameter.startsWith('spin.row.') || parameter === 'spin.swapSides' || parameter === 'spin.wheel' || parameter === 'spin.freeDrag' || parameter === 'spin.initialize' || parameter === 'spin.inactivity') childName = '5'; // Assuming 'Other' child is '5'
    else childName = '1'; // Default Spin child
  }
  else if (parameter.startsWith('thumbnails.')) parentName = '3';
  else if (parameter.startsWith('slide.')) parentName = '4';
  else if (parameter.startsWith('fullscreen.')) parentName = '5';
  else if (parameter.startsWith('layout.') || [
    'quality', 'hdQuality', 'itemsOrder', 'threshold', 'arrows', 'loop', 'orientation', 'autostart'
    ].includes(parameter)) parentName = '6'; // Viewer section
  else if (parameter.startsWith('contextmenu.')) parentName = '7';
  else if (parameter.startsWith('video.')) parentName = '8';
  else if (parameter.startsWith('model.')) {
       parentName = '9';
       // Determine model child
       if (parameter.startsWith('model.shadow.') || parameter.startsWith('skybox.') || parameter === 'environmentImage' || parameter.startsWith('camera.')) childName = '1'; // Surrounding
       else if (parameter.startsWith('model.animation.')) childName = '1'; // Animation (Check name, might be '2')
       else if (parameter.startsWith('model.ar.')) childName = '2'; // AR (Check name, might be '3')
       // No specific child for top-level model options like model.zoom, model.hint.finger etc.
  }
  else if (parameter.startsWith('lazyImage.')) parentName = '10'; // Single Image
  // Note: CSS/JS handled separately

  return { parentName, childName };
}

export default {
  name: "OptionElements",
  components: {
    SelectInput,
    SelectInputCustom,
    NumberInput,
    TextInput,
    SelectExtendedNum,
    RadioExtendedNum,
    RadioExtendedNumText,
    SliderInput,
    RadioInput,
    RadioInputAltImage,
    OrderInput,
    SpinControlPanel,
    SeoTextInput,
    NumberInputCustomDouble,
    NumberInputSelect,
    NumberInputThreeSelect,
  },
  mixins: [enabledField],
  data() {
    return {
      collapseChildren: [],
      queryChangeParams: [],
      isZoomEnable: this.zoomEnable,
    };
  },
  computed: {
    ...mapState([
      "collapseOptions",
      "collapseOptionsCSS",
      "collapseOptionsJS",
      "settings",
      "zoomEnable",
      "clearOptions",
    ]),
    ...mapGetters([
      "getImageAssets",
      "getSpinAssets",
      "getVideoAssets",
      "getViewAssets",
      "getModelAssets",
      "getPanoramaAssets",
    ]),
    collapseParent,
    collapseCSS,
    collapseChildCSS,
    collapseJS,
    collapseChildJS,
    normalizeCollapseOptions() {
      return this.collapseOptions.filter((it) => it.title !== "JS" && it.title !== "Dimensions");
    },
    optionsCSSCopy() {
      return this.settings.optionsCSS;
    },
  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.collapseChildren = '';
        this.collapseCSS = '1';
        this.collapseChildCSS = '';
        this.collapseJS = '1';
      }
    },
    collapseParent(val) {
      if (val === "1") {
        this.$store.dispatch("enableZoom", true);
      }
    },
    collapseOptions(newOptionsData, oldOptionsData) {
        const configUrl = this.$route.query?.config ? this.$route.query.config : null;
        if (configUrl) {
          // If config URL exists, call the tab determination method with delay
          // to ensure the config data is loaded
          setTimeout(() => {
            this.loadLastActiveTabFromConfig();
          }, 500);
          return;
        }
        if (oldOptionsData && oldOptionsData.length > 0) return; 

        let initialTargetParent = null;
        const fileUrl = this.$route.query?.file ? this.$route.query.file : null;
        if (fileUrl !== null) {
          if (this.getSpinAssets.length) initialTargetParent = "2";
          else if (this.getVideoAssets.length) initialTargetParent = "8";
          else if (this.getModelAssets.length) initialTargetParent = "9";
          else if (this.getImageAssets.length) initialTargetParent = "1";
        }

        const finalInitialParent = initialTargetParent;

        if (this.collapseParent !== finalInitialParent && finalInitialParent !== null) {
            this.collapseParent = finalInitialParent;
        } else if (finalInitialParent === null && this.collapseParent !== '') {
             // If no asset determined parent, ensure it's closed initially
        }
        
        if (this.collapseChildren !== '') {
            this.collapseChildren = '';
        }
    },
    collapseOptionsCSS(newCSSData, oldCSSData) {
        if (oldCSSData && oldCSSData.length > 0) return;
        if (this.collapseCSS !== '1') {
             this.collapseCSS = '1';
        }
        if (this.collapseChildCSS !== '') {
            this.collapseChildCSS = '';
        }
    },
    collapseOptionsJS(newJSData, oldJSData) {
        if (oldJSData && oldJSData.length > 0) return;
        let initialTargetJS = '';
         if (Array.isArray(newJSData)) {
             const jsSection = newJSData.find(section => section.name === '11');
             if (jsSection && (
                    (jsSection.items && jsSection.items.some(item => item.parameter)) ||
                    (jsSection.collapseChildOptions && jsSection.collapseChildOptions.some(child =>
                        child.items && child.items.some(item => item.parameter)
                 ))
                )) {
                 initialTargetJS = '11';
             }
         }
        if (this.collapseJS !== initialTargetJS) {
            this.collapseJS = initialTargetJS;
        }
    },
    'settings.options': {
      handler(newOptions) {
        // If we have a config in URL and options are not empty, try to open the tab
        const configUrl = this.$route.query?.config ? this.$route.query.config : null;
        if (configUrl && newOptions) {
          this.loadLastActiveTabFromConfig();
        }
      },
      immediate: true
    },
  },
  methods: {
    /**
     * Load and activate the last active tab from configuration
     * This method analyzes the options from the loaded config
     * and determines which tab should be opened based on the last parameter
     */
    loadLastActiveTabFromConfig() {
      try {
        // Get settings from store
        const optionString = this.settings.options;
        
        if (!optionString) {
          console.log('Error: Options not found in settings');
          return;
        }
        
        // Parse the options string to get all parameters
        const optionParams = this.parseOptionsString(optionString);
        
        if (optionParams.length === 0) {
          console.log('Warning: No parameters to process');
          return;
        }
        
        // Get the last modified parameter from the list
        const lastParam = optionParams[optionParams.length - 1];
        if (!lastParam || !lastParam.parameter) {
          console.log('Error: Cannot determine the last parameter');
          return;
        }
        
        console.log('Last parameter:', lastParam);
        
        // Get the corresponding tab numbers for the found parameter
        const { parentName, childName } = getSectionNamesFromParameter(lastParam.parameter);
        console.log('Detected tab:', { parentName, childName });
        
        // Set active tabs
        this.activateDetectedTabs(parentName, childName);
      } catch (error) {
        console.error('Error in loadLastActiveTabFromConfig:', error);
      }
    },
    
    /**
     * Parse options string into an array of parameter objects
     * @param {string} optionString - The options string to parse
     * @return {Array} Array of parameter objects
     */
    parseOptionsString(optionString) {
      if (!optionString) return [];
      
      return optionString.split(' ')
        .filter(Boolean)
        .map(item => {
          // Skip parameters without ":" separator
          if (item.indexOf(':') === -1) return null;
          
          try {
            const [paramWithSeparator, value] = item.split(':');
            if (!paramWithSeparator) return null;
            
            const parameter = paramWithSeparator.replace(/\.$/, ''); // Remove dot at the end if exists
            return { 
              parameter, 
              value: value?.replace(/;$/, '') // Remove semicolon at the end of value
            };
          } catch (e) {
            console.error('Error parsing option:', item, e);
            return null;
          }
        })
        .filter(Boolean);
    },
    
    /**
     * Activate the detected parent and child tabs
     * @param {string} parentName - Parent tab identifier
     * @param {string} childName - Child tab identifier
     */
    activateDetectedTabs(parentName, childName) {
      if (!parentName) return;
      
      // Open parent tab first
      if (this.collapseParent !== parentName) {
        this.collapseParent = parentName;
      }
      
      // If there's a child tab, open it with a delay
      if (childName) {
        setTimeout(() => {
          this.collapseChildren = childName;
        }, 100);
      }
    },
    
    checkZoomOption(params) {
      this.$store.dispatch("enableZoom", params);
    },
    changeOption(params) {
      this.queryChangeParams = this.queryChangeParams.filter(
        (item) => item.parameter !== params.parameter
      );

      if (params.value !== undefined && params.value !== '') {
        this.queryChangeParams.push(params);
      }

      const videoThumbnail = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "video.thumbnail"
      );

      videoThumbnail
        ? this.$store.dispatch("video/setVideoThumbnailStatus", true)
        : this.$store.dispatch("video/setVideoThumbnailStatus", false);

      const modelThumbnail = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "model.thumbnail"
      );

      modelThumbnail
        ? this.$store.dispatch("model/setModelThumbnailStatus", true)
        : this.$store.dispatch("model/setModelThumbnailStatus", false);

      const modelSkybox = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "skybox.image"
      );

      modelSkybox
        ? this.$store.dispatch("model/setModelSkyboxStatus", true)
        : this.$store.dispatch("model/setModelSkyboxStatus", false);

      const modelEnvironment = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "environmentImage"
      );

      modelEnvironment
        ? this.$store.dispatch("model/setModelEnvironmentStatus", true)
        : this.$store.dispatch("model/setModelEnvironmentStatus", false);

      const modelSkyboxHeight = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "skybox.height"
      );

      modelSkyboxHeight
        ? this.$store.dispatch("model/setModelSkyboxHeightStatus", true)
        : this.$store.dispatch("model/setModelSkyboxHeightStatus", false);

      const modelCameraOrbit = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "camera.orbit"
      );

      modelCameraOrbit
        ? this.$store.dispatch("model/setModelCameraOrbitStatus", true)
        : this.$store.dispatch("model/setModelCameraOrbitStatus", false);

      const modelCameraTarget = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "camera.target"
      );

      modelCameraTarget
        ? this.$store.dispatch("model/setModelCameraTargetStatus", true)
        : this.$store.dispatch("model/setModelCameraTargetStatus", false);

      const inlineModeSMV = this.queryChangeParams.find(
        (item) => `${item.parameter}` === "inlineModeSMV"
      );

      inlineModeSMV
        ? this.$store.dispatch("inlineModeSMV/setInlineModeSMV", true)
        : this.$store.dispatch("inlineModeSMV/setInlineModeSMV", false);

      const zoomEnabled = this.queryChangeParams.find(
        (item) => `${item.parameter}${item.separator}${item.value}` === "zoom.enable:true"
      );

      const zoomDisabled = this.queryChangeParams.find(
        (item) => `${item.parameter}${item.separator}${item.value}` === "zoom.enable:false"
      );

      const panoramaEnabled = this.queryChangeParams.find(
        (item) => `${item.parameter}${item.separator}${item.value}` === "panorama.enable:true"
      );

      if (zoomEnabled) {
        this.checkZoomOption(true);
        this.$store.dispatch("zoomEnable", true);
      } else if (zoomDisabled) {
        this.checkZoomOption(false);
      } else if (!zoomEnabled && !zoomDisabled && this.isZoomEnable === true) {
        this.checkZoomOption(true);
      }

      this.$store.dispatch("changeOption", {
        option: this.queryChangeParams
          .map((item) => `${item.parameter}${item.separator}${item.value};`)
          .join(" ")
      });

      this.$store.dispatch("changeOptionCSS", {
        optionCSS: this.optionsCSSCopy,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.without-bottom-b {
  border-bottom: none;
}
</style>
